"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

var _user = require("../../redux/modules/user");

var _helpersStylesIcons = require("./helpers-styles-icons");

var _HyperWalletFormPopup = require("./HyperWalletFormPopup");

var _HyperWalletFormPopup2 = _interopRequireDefault(_HyperWalletFormPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundProgressView = function (_React$Component) {
  (0, _inherits3.default)(RefundProgressView, _React$Component);

  function RefundProgressView(props) {
    (0, _classCallCheck3.default)(this, RefundProgressView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RefundProgressView.__proto__ || (0, _getPrototypeOf2.default)(RefundProgressView)).call(this, props));

    _this.handleRetry = function () {
      _this.props.dialogs.custom(_react2.default.createElement(_HyperWalletFormPopup2.default, { isRetrying: true }), {
        preventCloseOnOutsideClick: true,
        preventCloseOnEscape: true
      });
    };

    return _this;
  }

  (0, _createClass3.default)(RefundProgressView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getStatusForCashRefund();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.cashRefundStatus.isLoading) {
        return _react2.default.createElement(
          "div",
          { className: _helpersStylesIcons.spinnerStyles },
          _react2.default.createElement(_Preloader2.default, null)
        );
      }

      var isError = ["FAILED", "EXPIRED", "RETURNED"].includes(this.props.cashRefundStatus.data.status);
      var isInProgress = ["PENDING_TRANSFER_METHOD_ACTION", "PENDING_TRANSACTION_VERIFICATION", "IN_PROGRESS"].includes(this.props.cashRefundStatus.data.status);
      var isComplete = ["COMPLETED"].includes(this.props.cashRefundStatus.data.status);

      var showRetry = ["FAILED", "RETURNED", "EXPIRED"].includes(this.props.cashRefundStatus.data.status) && this.props.cashRefundStatus.data.retriesCount <= this.props.cashRefundStatus.data.maxRetries;

      var showRetryWhenCancelled = ["CANCELLED"].includes(this.props.cashRefundStatus.data.status) && this.props.cashRefundStatus.data.isRetryAllowedAfterCancellation && this.props.cashRefundStatus.data.retriesCount <= this.props.cashRefundStatus.data.maxRetries;

      var propBag = {
        icon: isError ? _react2.default.createElement(_helpersStylesIcons.ErrorIconSvg, null) : isComplete ? _react2.default.createElement(_helpersStylesIcons.SuccessIconSvg, null) : _react2.default.createElement(_helpersStylesIcons.WaitingIconSvg, null),
        color: isError ? "#FF6173" : isComplete ? "#A9D34F" : "#FFC229",
        text: isError ? "Processing error" : isInProgress ? "Processing your points conversion request" : isComplete ? "Success!" : "No refund in progress",
        subtext: isError ? _react2.default.createElement(
          "div",
          null,
          "An error has occurred and we cannot complete your points conversion request.",
          _react2.default.createElement("br", null),
          "Please contact",
          " ",
          _react2.default.createElement(
            "a",
            { href: _config2.default.forumBaseUrl, className: _helpersStylesIcons.anchorStyles, target: "_blank" },
            "our support team"
          ),
          "."
        ) : isInProgress ? _react2.default.createElement(
          "div",
          null,
          "For assistance, please contact",
          " ",
          _react2.default.createElement(
            "a",
            { href: _config2.default.forumBaseUrl, className: _helpersStylesIcons.anchorStyles, target: "_blank" },
            "our support team"
          ),
          "."
        ) : isComplete ? _react2.default.createElement(
          "div",
          null,
          "Your points have been converted successfully to a cash refund.",
          _react2.default.createElement("br", null),
          "For additional assistance, contact",
          " ",
          _react2.default.createElement(
            "a",
            { href: _config2.default.forumBaseUrl, className: _helpersStylesIcons.anchorStyles, target: "_blank" },
            "our support team"
          ),
          "."
        ) : _react2.default.createElement(
          "div",
          null,
          "If you need assistance, contact",
          " ",
          _react2.default.createElement(
            "a",
            { href: _config2.default.forumBaseUrl, className: _helpersStylesIcons.anchorStyles, target: "_blank" },
            "our support team"
          ),
          "."
        )
      };

      if (["PENDING_TRANSFER_METHOD_ACTION"].includes(this.props.cashRefundStatus.data.status)) {
        propBag.text = "Claim your payment by email sent through HyperWallet";
      }

      if (showRetry || showRetryWhenCancelled) {
        propBag.subtext = _react2.default.createElement(
          "div",
          null,
          "An error has occurred and we cannot complete your points conversion request.",
          _react2.default.createElement("br", null),
          "Please contact",
          " ",
          _react2.default.createElement(
            "a",
            { href: _config2.default.forumBaseUrl, className: _helpersStylesIcons.anchorStyles, target: "_blank" },
            "our support team"
          ),
          " ",
          "or",
          " ",
          _react2.default.createElement(
            "span",
            { className: _helpersStylesIcons.anchorStyles, onClick: this.handleRetry },
            "try again"
          ),
          "."
        );
      }

      return _react2.default.createElement(
        "div",
        { className: _helpersStylesIcons.page },
        _react2.default.createElement(
          "h2",
          { className: _helpersStylesIcons.title },
          "Convert your Quixel points"
        ),
        _react2.default.createElement(
          "section",
          { className: _helpersStylesIcons.refundProgessSummary },
          _react2.default.createElement(
            "div",
            { className: (0, _helpersStylesIcons.boxStyles)({ display: "flex", gap: "12px" }) },
            _react2.default.createElement(
              "span",
              {
                className: (0, _helpersStylesIcons.boxStyles)({ marginTop: "-2px", "& svg > path": { fill: propBag.color } }) },
              propBag.icon
            ),
            _react2.default.createElement(
              "div",
              {
                className: (0, _helpersStylesIcons.boxStyles)({
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  alignItems: "flex-start"
                }) },
              _react2.default.createElement(
                "div",
                { className: (0, _helpersStylesIcons.textStyles)({ weight: "600", color: "white" }) },
                propBag.text
              ),
              _react2.default.createElement(
                "div",
                { style: { fontSize: "16px", lineHeight: "22px" } },
                propBag.subtext
              )
            )
          )
        )
      );
    }
  }]);
  return RefundProgressView;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    cashRefundStatus: state.user.cashRefundStatus
  };
}, { getStatusForCashRefund: _user.getStatusForCashRefund })(RefundProgressView);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ConvertPoints/RefundProgressView.jsx
// module id = 2917
// module chunks = 0